import moment from 'moment'

export default function preparePlotData({ frames, t0, t1, allPlots }) {
  // console.error('Preparing rows from %s frames', frames.length)
  let result = []
  for (let frame of frames) {
    if (frame.type == 'event') {
      const lapse = frame.event
      const timestamp = frame.event.timestamp
      const sample = getSample(frame.event)
      makeBigInts(sample)

      const values = getAllValues({ allPlots, lapse, sample })

      result.push({ timestamp, lapse, sample, values })
    } else if (frame.type == 'lapses') {
      const header = frame.header
      if (header != null) {
        const t0 = moment(header.header.timestamp) // wtf
        frame.lapses.forEach((lapse, i) => {
          const timestamp = moment(t0)
            .add(i, 's')
            .toDate()
          const sample = getSample(lapse)
          makeBigInts(sample)
          const values = getAllValues({ allPlots, lapse, sample })
          result.push({ timestamp, lapse, sample, values })
        })
      }
    }
  }

  result = result.filter((x) => {
    if (t0 != null && moment(t0).isAfter(x.timestamp)) return false
    if (t1 != null && moment(t1).isBefore(x.timestamp)) return false
    return true
  })

  // Para cada lapso L, copia os valores do lapso L-1 que não estão
  // definidos neste (para evitar que as linhas dos gráficos fiquem
  // pontilhadas)
  for (let i = 1; i < result.length; i++) {
    // result[i].lapse = Object.assign({}, result[i - 1].lapse, result[i].lapse)
    // result[i].values = Object.assign({}, result[i - 1].values, result[i].values)
    merge(result[i].lapse, result[i - 1].lapse)
    merge(result[i].values, result[i - 1].values)
  }

  return result
}

function getSample(lapse) {
  if (lapse.operations == null) return null
  const op = lapse.operations.find((x) => x.subTypeStr == 'sniff')
  if (op == null) return null
  return op.sample
}

function makeBigInts(sample) {
  if (sample == null) return null
  for (let variable of sample) {
    // eslint-disable-next-line no-undef
    variable.bigValue = BigInt('0x' + variable.hexValue)
  }
}

function getAllValues({ allPlots, lapse, sample }) {
  const values = {}
  for (let plotConfig of allPlots) {
    values[plotConfig.id] = plotConfig.getter({ lapse, sample })
  }
  return values
}

function merge(dest, src) {
  // Copia props de src para dest desde que ela
  // esteja NULL em dest.
  for ( let [key, value] of Object.entries(src) ) {
    if ( dest[key] == null ) {
      dest[key] = value
    }
  }
}